//@import "bootstrap-sass/assets/javascripts/bootstrap.js";

import Materialize from 'materialize-css';
import Slick from 'slick-carousel';
//import Isotope from 'isotope-layout';
//import ScrollMagic from 'scrollmagic/scrollmagic/uncompressed/ScrollMagic.js';
//import ScrollMagicInit from 'modules/scrollfire/init';

// vendor
require('./vendor/fancybox-init');
require('./vendor/jquery-confirm');

// modules
require('./modules/header/');
require('./modules/slider/');
require('./modules/maps/filter-map');
require('./modules/maps/single-map');
//require('./modules/filter/tabs');
require('./modules/filter/filter');
require('./modules/scroll/init');
// require('./modules/scroll/parallax');
require('./modules/tabs/');
require('./modules/overlay/');
require('./modules/accordion/');
require('./modules/securearea/');
require('./modules/login-modal/');


// init global materialize stuff
$(document).ready(function() {	
	$('select').material_select();
	$('.collapsible').collapsible();
});


/** WEBPACK FOOTER **
 ** ./Frontend/js/app.js
 **/